<script setup>
import {mdiPencil} from "@mdi/js";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    small: {
        type: Boolean,
        default: false,
    },
    disableEdit: {
        type: Boolean,
        default: false,
    }
});
const emit = defineEmits(['edit']);
</script>

<template>
    <div class="wizard-summary__field">
        <div class="wizard-summary__field-title">
            {{ title }}
        </div>
        <div class="wizard-summary__field-value" :class="{'wizard-summary__field-value--small': small}">
            <slot></slot>
        </div>
        <div class="wizard-summary__field-action">
            <v-btn v-if="!disableEdit" @click="emit('edit')" size="small" :prepend-icon="mdiPencil">
                {{ pgettext('action', 'Edit') }}
            </v-btn>
        </div>
    </div>
</template>
